import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
    private _authorizationHeader: string;
    private static Key: string = "AuthorizationToken";

    constructor() {
    }

    public get authorizationHeader() : string
    {
        return this._authorizationHeader || localStorage.getItem(AuthService.Key);
    }

    public registerTokenFromGlobal() {
        let token = accessToken;
        if (token) {
            sessionStorage.setItem(AuthService.Key, token);
        } else {
            token = sessionStorage.getItem(AuthService.Key);
        }
        this._authorizationHeader = 'Bearer ' + token;
    }
}
